export function formatBytes(bytes: number, decimals = 1): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);

  return `${value.toFixed(decimals)} ${sizes[i]}`;
}

export function formatTimeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'az önce';
  if (minutes < 60) return `${minutes} dk önce`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} sa önce`;
  return `${Math.floor(hours / 24)} gün önce`;
}

export function formatUpcomingDate(dateInput: string | null | undefined): string {
  if (!dateInput) return '-';
  const datePart = dateInput.split('T')[0].split(' ')[0];
  const [year, month, day] = datePart.split('-').map((n) => parseInt(n, 10));
  if (!year || !month || !day) return '-';

  const date = new Date(year, month - 1, day);
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diffMs = date.getTime() - todayStart.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  const label = date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
  if (diffDays === 0) return `Bugün · ${label}`;
  if (diffDays === 1) return `Yarın · ${label}`;
  return label;
}

export function getUpcomingRelativeDay(dateInput: string | null | undefined): string | null {
  if (!dateInput) return null;
  const datePart = dateInput.split('T')[0].split(' ')[0];
  const [year, month, day] = datePart.split('-').map((n) => parseInt(n, 10));
  if (!year || !month || !day) return null;

  const date = new Date(year, month - 1, day);
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diffDays = Math.round((date.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Bugün';
  if (diffDays === 1) return 'Yarın';
  return null;
}

/** Backend hata yanıtından kullanıcıya gösterilecek mesajı çıkarır. */
export function getBackendError(err: unknown): string | null {
  const e = err as { response?: { data?: { message?: string; errors?: Record<string, string[]> } } };
  if (e.response?.data?.message) return e.response.data.message;
  if (e.response?.data?.errors) {
    return Object.values(e.response.data.errors).flat().join(" ");
  }
  return null;
}

/** 12345.6 → "12.345,60" (tr-TR). */
export function formatMoney(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (n === null || n === undefined || !Number.isFinite(n)) return '0,00';
  return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
